/**
 * Conversion des listes de nombres saisies en texte libre.
 *
 * Les valeurs proposées d'une commission variable sont saisies dans un seul champ.
 * L'ancien back-office imposait un tableau de champs distincts, pénible à saisir et à
 * réordonner.
 *
 * Convention : le point-virgule (ou un retour à la ligne, ou une espace) sépare les
 * valeurs, la virgule reste le séparateur décimal français. « 5 ; 7,5 ; 10 » donne donc
 * [5, 7.5, 10]. La virgule ne peut pas jouer les deux rôles à la fois.
 */

const ITEM_SEPARATORS = /[;\s]+/;

export const parseNumberList = (input: string): number[] =>
  input
    .split(ITEM_SEPARATORS)
    .map((chunk) => chunk.trim().replace(',', '.'))
    .filter((chunk) => chunk.length > 0)
    .map(Number)
    .filter((value) => Number.isFinite(value));

export const formatNumberList = (values?: number[] | null): string =>
  (values ?? []).map((value) => String(value).replace('.', ',')).join(' ; ');
